export const REQUEST_ADD_NEW_DEPO_FILE = "REQUEST_ADD_NEW_DEPO_FILE";
export const ON_DROP = "ON_DROP";
export const SET_INFORMATIONS = "SET_INFORMATIONS";
export const SET_TOASTER = "SET_TOASTER";
export const REMOVE_TOASTER = "REMOVE_TOASTER";
export const SET_LOAD_PERCENT = "SET_LOAD_PERCENT";
export const REMOVE_BUTTON = "REMOVE_BUTTON";
export const REMOVE_FILE_FROM_LIST = "REMOVE_FILE_FROM_LIST";
export const REMOVE_FILE_FROM_UPLOADS_LIST = "REMOVE_FILE_FROM_UPLOADS_LIST";
export const RESET_ALL_PROPS = "RESET_ALL_PROPS";
export const CHECK_IF_SENT = "CHECK_IF_SENT";
export const REQUEST_GET_FILES = "REQUEST_GET_FILES";
export const SET_LIST_FILES = "SET_LIST_FILES";
export const SET_READY_TO_SEND = "SET_READY_TO_SEND";
export const READY_TO_SEND = "READY_TO_SEND";
export const SET_ALMOST_READY = "SET_ALMOST_READY";
export const SET_VALUE_SELECT = "SET_VALUE_SELECT";
